import { Controller } from '@hotwired/stimulus'

const CONSTRUCTION_INDUSTRY = 'construction'

export default class AccountFormController extends Controller {
  static targets = [
    'industry',
    'hasEdlus',
    'hasScheduler',
    'hasTasker',
    'edlusChild',
    'schedulerChild',
    'taskerChild',
    'useNewSchedules',
    'canUseHorizon'
  ]

  static values = { industry: String }

  connect() {
    this.toggleChildCheckboxes()
  }

  industryValueChanged() {
    this.toggleHorizonAvailability()
  }

  changeIndustry() {
    this.industryValue = this.industryTarget.querySelector('select').value
  }

  toggleSchedulerChildren() {
    if (this.hasSchedulerTarget.checked && this.hasUseNewSchedulesTarget) this.useNewSchedulesTarget.checked = true
    this.toggleChildCheckboxes()
  }

  toggleChildCheckboxes() {
    if (!this.hasHasEdlusTarget) return

    const edlusEnabled = this.hasEdlusTarget.checked
    const schedulerEnabled = edlusEnabled && this.hasHasSchedulerTarget && this.hasSchedulerTarget.checked
    const taskerEnabled = this.hasHasTaskerTarget && this.hasTaskerTarget.checked

    this.edlusChildTargets.forEach(element => element.classList.toggle('d-none', !edlusEnabled))
    this.schedulerChildTargets.forEach(element => element.classList.toggle('d-none', !schedulerEnabled))
    this.taskerChildTargets.forEach(element => element.classList.toggle('d-none', !taskerEnabled))
  }

  toggleHorizonAvailability() {
    if (!this.hasCanUseHorizonTarget) return

    const constructionIndustry = this.industryValue === CONSTRUCTION_INDUSTRY

    if (!constructionIndustry) this.canUseHorizonTarget.checked = false
    this.canUseHorizonTarget.disabled = !constructionIndustry
  }
}
